// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Banner_wrapper__2QAx4"};